'use es6';

import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";

var _class, _temp, _class2, _temp2, _class3, _temp3;

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Immutable from 'immutable';
import styled from 'styled-components';
import { omit } from 'underscore';
import ContentRoutes from 'ContentUtils/Routes';
import { OBSIDIAN } from 'HubStyleTokens/colors';
import { WEB_FONT_MEDIUM_WEIGHT } from 'HubStyleTokens/misc';
import FormattedCurrency from 'I18n/components/FormattedCurrency';
import FormattedList from 'I18n/components/FormattedList';
import FormattedMessage from 'I18n/components/FormattedMessage';
import * as CustomRenderer from 'UIComponents/utils/propTypes/customRenderer';
import UIButton from 'UIComponents/button/UIButton';
import UIBox from 'UIComponents/layout/UIBox';
import UICardHero from 'UIComponents/card/UICardHero';
import UICardSection from 'UIComponents/card/UICardSection';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILink from 'UIComponents/link/UILink';
import UIIconRating from 'UIComponents/input/UIIconRating';
import UIImage from 'UIComponents/image/UIImage';
import UIHoverlay from 'UIComponents/overlay/UIHoverlay';
import UISection from 'UIComponents/section/UISection';
import UITruncateString from 'UIComponents/text/UITruncateString';
import Small from 'UIComponents/elements/Small';
import * as GoodTypes from '../../constants/GoodTypes';
import ModuleCompatibilityTagTypes from '../../constants/ModuleCompatibilityTagTypes';
import PackCounts from './PackCounts';
import ThemeAssets from './ThemeAssets';
var MAX_TILE_WIDTH = 480;
var MINIMUM_REQUIRED_REVIEWS = 3;
var StyledCardWrapper = styled(UICardWrapper).withConfig({
  displayName: "GoodTile__StyledCardWrapper",
  componentId: "xhg701-0"
})(["color:", ";font-weight:", ";max-width:", "px;"], OBSIDIAN, WEB_FONT_MEDIUM_WEIGHT, function (props) {
  return props.maxWidth;
});
var StyledAspectRatioContainer = styled.div.withConfig({
  displayName: "GoodTile__StyledAspectRatioContainer",
  componentId: "xhg701-1"
})(["height:0;padding-bottom:75%;color:white;background-color:white;"]);

var TemplateDeviceHeader = /*#__PURE__*/function (_Component) {
  _inherits(TemplateDeviceHeader, _Component);

  function TemplateDeviceHeader() {
    _classCallCheck(this, TemplateDeviceHeader);

    return _possibleConstructorReturn(this, _getPrototypeOf(TemplateDeviceHeader).apply(this, arguments));
  }

  _createClass(TemplateDeviceHeader, [{
    key: "render",
    value: function render() {
      return React.createElement(UIFlex, {
        justify: "start",
        align: "center",
        className: "good-tile-template-header"
      }, React.createElement("span", {
        className: "good-tile-template-circle"
      }), React.createElement("span", {
        className: "good-tile-template-circle"
      }), React.createElement("span", {
        className: "good-tile-template-circle"
      }));
    }
  }]);

  return TemplateDeviceHeader;
}(Component);

var BaseTile = (_temp = _class = /*#__PURE__*/function (_Component2) {
  _inherits(BaseTile, _Component2);

  function BaseTile() {
    _classCallCheck(this, BaseTile);

    return _possibleConstructorReturn(this, _getPrototypeOf(BaseTile).apply(this, arguments));
  }

  _createClass(BaseTile, [{
    key: "renderTileLink",
    value: function renderTileLink(children) {
      var _this$props = this.props,
          goodUrlToken = _this$props.goodUrlToken,
          LinkComponent = _this$props.linkRenderer,
          onClick = _this$props.onClick,
          previewMode = _this$props.previewMode;

      if (previewMode || !goodUrlToken) {
        return children;
      }

      return CustomRenderer.render(LinkComponent, {
        children: children,
        href: this.linkHref,
        onClick: onClick,
        style: {
          textDecoration: 'none'
        }
      });
    }
  }, {
    key: "renderTileContent",
    value: function renderTileContent() {
      var _this$props2 = this.props,
          goodContentComponent = _this$props2.goodContentComponent,
          goodImageUrl = _this$props2.goodImageUrl,
          goodName = _this$props2.goodName,
          hoverlayContent = _this$props2.hoverlayContent;
      var renderedContent = React.createElement(StyledAspectRatioContainer, null, goodContentComponent || React.createElement(UIImage, {
        src: goodImageUrl,
        alt: goodName
      }));

      if (hoverlayContent) {
        return renderedContent;
      }

      return this.renderTileLink(renderedContent);
    }
  }, {
    key: "renderRating",
    value: function renderRating(reviewInfo) {
      if (!reviewInfo || reviewInfo.get('totalCount') < MINIMUM_REQUIRED_REVIEWS) {
        return React.createElement(Small, {
          use: "help"
        }, React.createElement(FormattedMessage, {
          message: "marketplacelib.goodTile.noRatings"
        }));
      }

      return React.createElement(UIIconRating, {
        defaultValue: reviewInfo.get('rating'),
        disabled: true,
        size: "xxs",
        showPercentage: true
      });
    }
  }, {
    key: "renderGoodPriceMessage",
    value: function renderGoodPriceMessage(free, price) {
      if (free) {
        return React.createElement(FormattedMessage, {
          message: "marketplacelib.goodTile.price.free"
        });
      }

      return React.createElement(FormattedCurrency, {
        value: price,
        unit: "$",
        precision: 0
      });
    }
  }, {
    key: "renderHoverlay",
    value: function renderHoverlay(hoverlayContent, renderedCard) {
      var renderedContent = React.createElement(UIFlex, {
        className: "p-all-4",
        direction: "column",
        justify: "between"
      }, React.createElement(UIBox, {
        grow: 1,
        shrink: 1,
        style: {
          overflowY: 'auto'
        }
      }, hoverlayContent), React.createElement(UIBox, {
        grow: 0,
        shrink: 0
      }, React.createElement(UIButton, {
        use: "primary"
      }, React.createElement(FormattedMessage, {
        message: "marketplacelib.goodTile.detailsButtonText"
      }))));
      return this.renderTileLink(React.createElement(UIHoverlay, {
        foregroundContent: renderedContent,
        use: "full-card"
      }, renderedCard));
    }
  }, {
    key: "renderCardWrapper",
    value: function renderCardWrapper() {
      var _this$props3 = this.props,
          cardClassName = _this$props3.cardClassName,
          cardProps = _this$props3.cardProps,
          contentClassName = _this$props3.contentClassName,
          goodName = _this$props3.goodName,
          goodPrice = _this$props3.goodPrice,
          goodSubType = _this$props3.goodSubType,
          isFree = _this$props3.isFree,
          maxWidth = _this$props3.maxWidth,
          onPackDetailsPage = _this$props3.onPackDetailsPage,
          reviewInfo = _this$props3.reviewInfo,
          showDevice = _this$props3.showDevice,
          showPrice = _this$props3.showPrice,
          showRating = _this$props3.showRating,
          showSubType = _this$props3.showSubType;
      return React.createElement(StyledCardWrapper, Object.assign({}, cardProps, {
        className: cardClassName,
        compact: true,
        maxWidth: maxWidth
      }), showDevice && React.createElement(TemplateDeviceHeader, null), React.createElement(UICardHero, {
        className: contentClassName
      }, this.renderTileContent()), React.createElement(UICardSection, {
        flush: true,
        className: "m-x-4 p-y-2"
      }, React.createElement(UIFlex, {
        justify: "between"
      }, React.createElement(UIBox, null, React.createElement(UITruncateString, null, goodName)), showRating && goodSubType !== GoodTypes.APP && React.createElement(UIBox, {
        shrink: 0
      }, onPackDetailsPage ? null : this.renderRating(reviewInfo))), React.createElement(UIFlex, {
        justify: "between"
      }, showSubType && React.createElement(Small, {
        use: "help"
      }, React.createElement(UITruncateString, null, React.createElement(FormattedMessage, {
        message: "marketplacelib.goodSubTypes." + goodSubType
      }))), showPrice && React.createElement(UIBox, {
        shrink: 0
      }, onPackDetailsPage || goodSubType === GoodTypes.APP ? null : this.renderGoodPriceMessage(isFree, goodPrice)))));
    }
  }, {
    key: "render",
    value: function render() {
      var hoverlayContent = this.props.hoverlayContent;
      var renderedCard = this.renderCardWrapper();

      if (hoverlayContent) {
        return this.renderHoverlay(hoverlayContent, renderedCard);
      }

      return renderedCard;
    }
  }, {
    key: "linkHref",
    get: function get() {
      return ContentRoutes.marketplace(this.props.goodUrlToken, this.props.redirectUrl);
    }
  }]);

  return BaseTile;
}(Component), _class.propTypes = {
  cardClassName: PropTypes.string,
  cardProps: PropTypes.object,
  contentClassName: PropTypes.string,
  goodName: PropTypes.string.isRequired,
  goodPrice: PropTypes.number,
  goodSubType: PropTypes.string.isRequired,
  goodContentComponent: PropTypes.node,
  goodImageUrl: PropTypes.string,
  goodUrlToken: PropTypes.string,
  hoverlayContent: PropTypes.node,
  isFree: PropTypes.bool,
  linkRenderer: CustomRenderer.propType.isRequired,
  maxWidth: PropTypes.number.isRequired,
  onClick: PropTypes.func,
  onPackDetailsPage: PropTypes.bool,
  previewMode: PropTypes.bool,
  redirectUrl: PropTypes.string,
  reviewInfo: PropTypes.instanceOf(Immutable.Map),
  showDevice: PropTypes.bool,
  showPrice: PropTypes.bool,
  showRating: PropTypes.bool,
  showSubType: PropTypes.bool
}, _class.defaultProps = {
  cardProps: {},
  isFree: false,
  linkRenderer: UILink,
  maxWidth: MAX_TILE_WIDTH,
  onPackDetailsPage: false,
  previewMode: false,
  showDevice: false,
  showPrice: true,
  showRating: true,
  showSubType: true
}, _temp);
var ModuleTile = (_temp2 = _class2 = /*#__PURE__*/function (_Component3) {
  _inherits(ModuleTile, _Component3);

  function ModuleTile() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ModuleTile);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ModuleTile)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.renderSummary = function (summary) {
      return summary && React.createElement(UISection, null, React.createElement("h5", {
        className: "m-bottom-1"
      }, _this.props.goodName), React.createElement("div", null, summary));
    };

    _this.renderCompatibility = function (_compatibility) {
      if (!(_compatibility && _compatibility.length)) {
        return null;
      }

      var compatibility = _compatibility;

      if (_this.isCompatibleWithAnyType) {
        compatibility = Object.keys(omit(ModuleCompatibilityTagTypes, ModuleCompatibilityTagTypes.COMPATIBLE_ANY));
      }

      return React.createElement(UISection, null, React.createElement("h5", {
        className: "m-bottom-2"
      }, React.createElement(FormattedMessage, {
        message: "marketplacelib.goodTile.moduleTile.compatibility.header"
      })), React.createElement(FormattedList, null, compatibility.map(function (type) {
        return React.createElement(FormattedMessage, {
          key: type,
          message: "marketplacelib.ModuleCompatibilityTagTypes." + type
        });
      })));
    };

    _this.renderHoverlay = function (compatibility, summary) {
      if (!(compatibility || summary)) {
        return null;
      }

      return React.createElement(UISection, null, _this.renderSummary(summary), _this.renderCompatibility(compatibility));
    };

    return _this;
  }

  _createClass(ModuleTile, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          moduleCompatibility = _this$props4.moduleCompatibility,
          moduleSummary = _this$props4.moduleSummary,
          rest = _objectWithoutProperties(_this$props4, ["moduleCompatibility", "moduleSummary"]);

      return React.createElement(BaseTile, Object.assign({}, rest, {
        hoverlayContent: this.renderHoverlay(moduleCompatibility, moduleSummary)
      }));
    }
  }, {
    key: "isCompatibleWithAnyType",
    get: function get() {
      var moduleCompatibility = this.props.moduleCompatibility;
      return moduleCompatibility && moduleCompatibility.some(function (type) {
        return type === ModuleCompatibilityTagTypes.COMPATIBLE_ANY;
      });
    }
  }]);

  return ModuleTile;
}(Component), _class2.propTypes = {
  goodName: PropTypes.string.isRequired,
  moduleCompatibility: PropTypes.arrayOf(PropTypes.oneOf(Object.keys(ModuleCompatibilityTagTypes))),
  moduleSummary: PropTypes.string
}, _temp2);

var AppTile = /*#__PURE__*/function (_Component4) {
  _inherits(AppTile, _Component4);

  function AppTile() {
    _classCallCheck(this, AppTile);

    return _possibleConstructorReturn(this, _getPrototypeOf(AppTile).apply(this, arguments));
  }

  _createClass(AppTile, [{
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          moduleSummary = _this$props5.moduleSummary,
          rest = _objectWithoutProperties(_this$props5, ["moduleSummary"]);

      var summary = moduleSummary.indexOf('span') > -1 ? moduleSummary.replace('<span>', '<h5 class="m-bottom-1">').replace('</span>', '</h5>') : "<h5 class=\"m-bottom-1\">" + rest.goodName + "</h5>" + moduleSummary;
      return React.createElement(BaseTile, Object.assign({}, rest, {
        hoverlayContent: React.createElement("div", {
          dangerouslySetInnerHTML: {
            __html: summary
          }
        })
      }));
    }
  }]);

  return AppTile;
}(Component);

var PackTile = (_temp3 = _class3 = /*#__PURE__*/function (_Component5) {
  _inherits(PackTile, _Component5);

  function PackTile() {
    _classCallCheck(this, PackTile);

    return _possibleConstructorReturn(this, _getPrototypeOf(PackTile).apply(this, arguments));
  }

  _createClass(PackTile, [{
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          packCounts = _this$props6.packCounts,
          rest = _objectWithoutProperties(_this$props6, ["packCounts"]);

      return React.createElement(BaseTile, Object.assign({}, rest, {
        hoverlayContent: React.createElement(PackCounts, {
          abbreviateList: true,
          packCounts: packCounts
        })
      }));
    }
  }]);

  return PackTile;
}(Component), _class3.propTypes = {
  packCounts: PropTypes.instanceOf(Immutable.List)
}, _class3.defaultProps = {
  packCounts: Immutable.List()
}, _temp3);

var TemplateTile = /*#__PURE__*/function (_Component6) {
  _inherits(TemplateTile, _Component6);

  function TemplateTile() {
    _classCallCheck(this, TemplateTile);

    return _possibleConstructorReturn(this, _getPrototypeOf(TemplateTile).apply(this, arguments));
  }

  _createClass(TemplateTile, [{
    key: "render",
    value: function render() {
      return React.createElement(BaseTile, this.props);
    }
  }]);

  return TemplateTile;
}(Component);

var ThemeTile = /*#__PURE__*/function (_Component7) {
  _inherits(ThemeTile, _Component7);

  function ThemeTile() {
    _classCallCheck(this, ThemeTile);

    return _possibleConstructorReturn(this, _getPrototypeOf(ThemeTile).apply(this, arguments));
  }

  _createClass(ThemeTile, [{
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          themeAssetNamesBySubType = _this$props7.themeAssetNamesBySubType,
          rest = _objectWithoutProperties(_this$props7, ["themeAssetNamesBySubType"]);

      return React.createElement(BaseTile, Object.assign({}, rest, {
        hoverlayContent: React.createElement(ThemeAssets, {
          abbreviateList: true,
          assetNamesBySubType: themeAssetNamesBySubType,
          showHeader: true
        })
      }));
    }
  }]);

  return ThemeTile;
}(Component);

var GoodTile = /*#__PURE__*/function (_Component8) {
  _inherits(GoodTile, _Component8);

  function GoodTile() {
    _classCallCheck(this, GoodTile);

    return _possibleConstructorReturn(this, _getPrototypeOf(GoodTile).apply(this, arguments));
  }

  _createClass(GoodTile, [{
    key: "render",
    value: function render() {
      var _this$props8 = this.props,
          goodType = _this$props8.goodType,
          rest = _objectWithoutProperties(_this$props8, ["goodType"]);

      switch (goodType) {
        case GoodTypes.CUSTOM_MODULE:
          return React.createElement(ModuleTile, rest);

        case GoodTypes.PACK:
          return React.createElement(PackTile, rest);

        case GoodTypes.CMS_THEME:
          return React.createElement(ThemeTile, rest);

        case GoodTypes.COS_TEMPLATE:
          return React.createElement(TemplateTile, rest);

        case GoodTypes.APP:
          return React.createElement(AppTile, rest);

        default:
          return null;
      }
    }
  }]);

  return GoodTile;
}(Component);

GoodTile.propTypes = {
  goodType: PropTypes.oneOf(Object.keys(GoodTypes)).isRequired
};
export { GoodTile as default };